import { Box, CircularProgress, Typography } from "@mui/material";
import React from "react";
import { useDirectus } from "../providers/DirectusProvider";
import Login from "./Login";

interface AuthGuardProps {
  children: React.ReactNode;
}

const AuthGuard: React.FC<AuthGuardProps> = ({ children }) => {
  const {
    auth: {
      state: { isAuthenticated, isLoading, user },
    },
  } = useDirectus();

  if (isAuthenticated && user) {
    return <>{children}</>;
  } else if (isLoading) {
    return (
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="100vh"
        gap={2}
      >
        <CircularProgress size={60} />
        <Typography variant="h6" color="text.secondary">
          Checking authentication...
        </Typography>
      </Box>
    );
  } else {
    return <Login />;
  }
};

export default AuthGuard;
